import Resource from './BaseResource'

class History extends Resource {
    constructor(config, tools, version, path) {
        super(config, tools, version, path)
    }
}

export default History